import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_AVAILABLE_HOURS } from "../queries/GetProductFamilies";

const fetchAvailableHours = async ({ queryKey }) => {
    const [, { token, lineName }] = queryKey;

    if (!token) throw new Error("Token not available");
    if (!lineName) throw new Error("Not product line found");

    try {
        const response = await axios.get(`/getAvailableHours`, {
            params: {
                currentDate: new Date().toDateString(),
                prodFamilyName: lineName,
            },
            headers: {
                Authorization: token,
            },
        });
        return response.data;

    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetAvailableHours = (params) => {
    return useQuery({
        queryKey: [GET_AVAILABLE_HOURS, params],
        queryFn: fetchAvailableHours,
        enabled: !!params.token && !!params.lineName,
        retry: false,
    });
};

